module.exports = __webpack_public_path__ + "static/retirar cup-d113217ff7ed1b8ae36008e29c63b909.png";